<template>
  <v-card min-height="100%">
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon @click="newItem()">mdi-plus-circle</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon @click="loadData()">mdi-refresh</v-icon>
      </v-btn>
    </v-card-actions>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="total"
        :loading="loading"
        item-key="id"
        :footer-props="{
          itemsPerPageOptions: [10, 25, 50]
        }"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-text-field
            v-model="filters.textFilter"
            label="Nome o Descrizione"
            outlined
            class="mx-1"
          ></v-text-field>
        </template>
        <template v-slot:[`item.id`]="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small class="mr-2" @click="showRange(item)">
            mdi-calendar-range
          </v-icon>
        </template>
        <template v-slot:[`item.dateCreated`]="{ item }">
          {{ item.dateCreated | formatDateTime }}
        </template>
        <template v-slot:[`item.lastUpdated`]="{ item }">
          {{ item.lastUpdated | formatDateTime }}
        </template>
        <template v-slot:[`item.defaultUser`]="{ item }">
          {{ getDefaultUserNameFromId(item.defaultUser.id) }}
          <v-icon
            small
            class="mr-2"
            @click="editDefaultUserItem(item.defaultUser.id)"
          >
            mdi-pencil
          </v-icon>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import table from "@/mixin/table";
import global from "@/mixin/global";
import users from "@/mixin/users";

export default {
  name: "JobRoleList",
  mixins: [table, users, global],
  data() {
    return {
      headers: [
        {
          text: " ",
          value: "id"
        },
        { text: "Codice", value: "code" },
        { text: "Descrizione", value: "description" },
        { text: "Contatto predefinito", value: "defaultUser" },
        { text: "Data creazione", value: "dateCreated" },
        { text: "Ultima modifica", value: "lastUpdated" }
      ],
      serverPath: "jobRole"
    };
  },
  methods: {
    editItem(item) {
      this.$router.push({ name: "JobRoleEdit", params: { id: item.id } });
    },
    showRange(item) {
      this.$router.push({ name: "JobRoleEditSlot", params: { id: item.id } });
    },
    newItem() {
      this.$router.push({ name: "JobRoleCreate" });
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
